export class ReportComboDateUtils {
	static getISOWeekInfo(date: Date): { year: number; week: number } {
		const tmp = new Date(date.getTime());
		tmp.setHours(0, 0, 0, 0);
		tmp.setDate(tmp.getDate() + 3 - ((tmp.getDay() + 6) % 7)); // go to Thursday

		const weekYear = tmp.getFullYear();
		const week1 = new Date(weekYear, 0, 4); // Jan 4 is always in week 1

		const weekNumber =
			1 + Math.round(((tmp.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7);

		return { year: weekYear, week: weekNumber };
	}
	static getISOWeekRange(year: number, week: number): { from: Date; to: Date } {
		// Jan 4 is always in week 1
		const jan4 = new Date(year, 0, 4);
		const day = jan4.getDay() || 7; // Sunday => 7
		const mondayOfWeek1 = new Date(jan4);
		mondayOfWeek1.setDate(jan4.getDate() - day + 1); // move to Monday

		const from = new Date(mondayOfWeek1);
		from.setDate(mondayOfWeek1.getDate() + (week - 1) * 7);
		from.setHours(0, 0, 0, 0);

		const to = new Date(from);
		to.setDate(from.getDate() + 6);
		to.setHours(23, 59, 59, 999);

		return { from, to };
	}
	static getNumberOfWeek(date: Date, previousWeek: number) {
		const shiftedDate = new Date(date);
		shiftedDate.setDate(date.getDate() - previousWeek * 7);
		return this.getISOWeekInfo(shiftedDate);
	}
	static getDateRangeForPreviousYear(date: Date, previousYears: number): { from: Date; to: Date } {
		const year = date.getFullYear() - previousYears;

		const from = new Date(year, 0, 1); // January 1st
		from.setHours(0, 0, 0, 0);

		const to = new Date(date);
		to.setFullYear(year);
		to.setHours(23, 59, 59, 999);

		return { from, to };
	}
	static getDateRangeForPreviousMonth(date: Date, previousMonths: number): { from: Date; to: Date } {
		const target = new Date(date);
		target.setMonth(target.getMonth() - previousMonths);

		const from = new Date(target.getFullYear(), target.getMonth(), 1, 0, 0, 0, 0);

		const lastDayOfMonth = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
		const day = Math.min(date.getDate(), lastDayOfMonth);

		const to = new Date(target.getFullYear(), target.getMonth(), day, 23, 59, 59, 999);

		return { from, to };
	}
}
